import { AsButton } from '@adserve/adserve-react-components';
import React, { useState, useEffect, useContext } from 'react';
import PropertySelectionModal from './PropertySelectionModal';
import { GetPropertyCostingTypes, GetPropertyTotals } from '../../../../services/CampaignsDataService';
import { AirtimePlanningContext } from '../../../../contexts/AirtimePlanningContext';
import SelectedPropertySelectionTable from './SelectedPropertySelectionTable/SelectedPropertySelectionTable';
import { sectionedPanelStyle } from '../../CampaignStyles';

export const headerStyle = {
    display: 'flex',
    fontFamily: 'Roboto',
    fontSize: 15,
    fontWeight: 500,
    justifyContent: 'left',
    marginLeft: 20
};

export const createButton = {
    width: 105,
    height: 40,
    fontSize: 14,
    fontWeight: 'bold'
};

const PropertySelectionDetails = ({
    campaign,
    readOnly,
    bookedReadOnly = false,
    setReadOnlyProperty,
    setMinDateActiveProperty,
    setMaxDateActiveProperty,
    updateCampaign,
    propertyTypes = [],
    propertyTotals,
    setPropertyTotals,
    recalcTotals,
    onDelete,
    dealStationPrices,
    formatLaydown,
    currentCampaignVersionId
}) => {
    const [isModalShowing, setIsModalShowing] = useState(false);
    const [propertyCostingTypes, setPropertyCostingTypes] = useState([]);

    const handleShowPropertySelectionCopy = () => {
        setIsModalShowing(true);
    };

    const loadCostingTypes = () => {
        GetPropertyCostingTypes().then((res) => {
            setPropertyCostingTypes(res?.data);
        });
    };

    useEffect(() => {
        loadCostingTypes();
    }, []);

    const updateWinPrice = (prop) => {
        const offAirPrice = parseFloat(prop.offAirCosts?.toFixed(2));
        let calcDealPrice = parseFloat(prop?.propertyDealPrice?.toFixed(2));
        let exactWeeks = true;
        if (prop.sandPPropertyTypeName === 'Ongoing') {
            let oldSandPBudget = prop.sandPBudget;

            if (!isNaN(offAirPrice)) oldSandPBudget -= offAirPrice;
            let weeks = 0;
            if (!isNaN(calcDealPrice)) {
                weeks = parseFloat(oldSandPBudget / calcDealPrice).toString();
                exactWeeks = !weeks.includes('.');
                calcDealPrice = calcDealPrice * prop.weeks;
            }
        } else {
            exactWeeks = false;
        }

        if (!prop?.hasOwnProperty('sandPBudget')) {
            prop.sandPBudget = 0;
            if (!isNaN(calcDealPrice)) prop.sandPBudget += calcDealPrice;
        }

        return prop;
    };

    return (
        <div style={sectionedPanelStyle}>
            <div style={{ display: 'flex', marginTop: 10, width: '100%', justifyContent: 'center', paddingBottom: 18 }}>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 10 }}>
                        <span
                            style={{ fontSize: 15, fontWeight: 500, marginLeft: 30, marginTop: 2 }}
                        >{`${window.translate('Property Selection')}`}</span>
                        <div style={{ display: 'flex' }}>
                            <AsButton
                                style={{ width: 125, height: 40, fontSize: 15 }}
                                disabled={readOnly || !campaign?.name}
                                handleClick={handleShowPropertySelectionCopy}
                            >
                                {window.translate('Select Property')}
                            </AsButton>
                        </div>
                    </div>
                    <SelectedPropertySelectionTable
                        readOnly={readOnly}
                        bookedReadOnly={bookedReadOnly}
                        campaign={campaign}
                        updateCampaign={updateCampaign}
                        propertyCostingTypes={propertyCostingTypes}
                        propertyTypes={propertyTypes}
                        propertyTotals={propertyTotals}
                        setPropertyTotals={setPropertyTotals}
                        onDelete={onDelete}
                        recalcTotals={recalcTotals}
                        updateWinPrice={updateWinPrice}
                        dealStationPrices={dealStationPrices}
                        formatLaydown={formatLaydown}
                        currentCampaignVersionId={currentCampaignVersionId}
                    />
                </div>
            </div>
            {isModalShowing && (
                <PropertySelectionModal
                    isShowing={isModalShowing}
                    setIsShowing={setIsModalShowing}
                    setReadOnlyProperty={setReadOnlyProperty}
                    setMinDateActiveProperty={setMinDateActiveProperty}
                    setMaxDateActiveProperty={setMaxDateActiveProperty}
                    campaign={campaign}
                    propertyTotals={propertyTotals}
                    setPropertyTotals={setPropertyTotals}
                    updateCampaign={updateCampaign}
                    recalcTotals={recalcTotals}
                    updateWinPrice={updateWinPrice}
                />
            )}
        </div>
    );
};

export default PropertySelectionDetails;
